import { createFileRoute, getRouteApi, redirect } from "@tanstack/react-router";
import { z } from "zod";

import { SignInPage } from "../auth/sign-in-page.tsx";

import type { ReactElement } from "react";

const route = getRouteApi("/sign-in/");

const SignIn = (): ReactElement => (
  <SignInPage isSignedOutForSecurity={route.useSearch().reason === "security"} />
);

export const Route = createFileRoute("/sign-in/")({
  validateSearch: z.object({ reason: z.literal("security").optional().catch(undefined) }),
  beforeLoad: async ({ context }) => {
    const user = await context.data.auth.currentUser();
    if (user?.isComplete === true) {
      throw redirect({ to: "/today" });
    }
  },
  component: SignIn,
});
